var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          directives: [
            {
              name: "loadmore",
              rawName: "v-loadmore",
              value: _vm.loadMore,
              expression: "loadMore",
            },
          ],
          attrs: {
            "filter-method": _vm.filterablenFn,
            filterable: "",
            clearable: "",
            "collapse-tags": "",
            multiple: !_vm.singleSelect,
            size: _vm.size,
            placeholder: _vm.placeholder || "请选择资源组",
          },
          on: { "visible-change": _vm.selectChange },
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v
            },
            expression: "value",
          },
        },
        [
          _vm._l(_vm.options, function (item) {
            return _c("el-option", {
              key: item.id,
              attrs: { label: item.name, value: item.id },
            })
          }),
          _vm.loading
            ? _c(
                "el-option",
                { attrs: { label: "", value: "", disabled: "" } },
                [
                  _c("div", { staticStyle: { "text-align": "center" } }, [
                    _c("i", { staticClass: "el-icon-loading" }),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }